/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Network_Inspector_Request_BodyInputs */

const en_mobile_network_inspector_request_body = /** @type {(inputs: Mobile_Network_Inspector_Request_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request body`)
};

const es_mobile_network_inspector_request_body = /** @type {(inputs: Mobile_Network_Inspector_Request_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo de solicitud`)
};

/**
* | output |
* | --- |
* | "Request body" |
*
* @param {Mobile_Network_Inspector_Request_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_network_inspector_request_body = /** @type {((inputs?: Mobile_Network_Inspector_Request_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Network_Inspector_Request_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_network_inspector_request_body(inputs)
	return en_mobile_network_inspector_request_body(inputs)
});